import styled from 'styled-components';
import { stripUnit } from 'polished';
import { dropdownSideSpacing } from 'styles/spacings';
import { brandColors, greenDark, grey400, grey200 } from 'styles/colors';
import {
	CheckboxCheckedIcon,
	CheckboxUncheckedIcon,
	CheckboxIndeterminateIcon,
} from 'components/icons';

export const Wrapper = styled.div`
	position: relative;
	z-index: 0;

	&:last-child {
		margin-bottom: 8px;
	}
`;

const borderLeftSize = 4;

export const Bar = styled.div`
	min-height: 48px;
	display: flex;
	padding: 14px ${dropdownSideSpacing} 14px
		${stripUnit(dropdownSideSpacing) - borderLeftSize}px;
	transition: 200ms ease-in-out;
	transition-property: background-color, border-color;

	& svg {
		font-size: 22px;
		margin: -2px 10px 0 2px;
	}
`;

export const Input = styled.input`
	position: absolute;
	z-index: 1;
	opacity: 0;
	width: 100%;
	height: 100%;
	cursor: pointer;

	&:disabled {
		cursor: default;
	}

	&:disabled + ${Bar} {
		color: ${grey200};
	}
`;

export const StyledCheckboxUncheckedIcon = styled(CheckboxUncheckedIcon)`
	display: none;
	font-size: 22px;
	min-width: 1em;
	fill: ${grey400};
	${Input}:not(:checked) + ${Bar} & {
		display: block;
	}
	${Input}:hover + ${Bar} & {
		fill: ${greenDark};
	}
	${Input}:disabled + ${Bar} &,
	${Input}:disabled:hover + ${Bar} & {
		fill: ${grey200};
	}
`;

export const StyledCheckboxCheckedIcon = styled(CheckboxCheckedIcon)`
	display: none;
	font-size: 22px;
	min-width: 1em;
	${Input}:checked + ${Bar} & {
		display: block;
		fill: ${brandColors.green};
	}

	${Input}:hover + ${Bar} & path:last-child {
		fill: ${greenDark};
	}

	${Input}:disabled + ${Bar} & path:last-child {
		fill: ${grey200};
	}
`;

export const StyledCheckboxIndeterminateIcon = styled(
	CheckboxIndeterminateIcon
)`
	font-size: 24px !important;
	position: relative;
	top: -1px;
	left: -1px;
	&& {
		margin-right: 8px;
	}
	fill: ${brandColors.green};

	${Input}:hover + ${Bar} & path:last-child {
		fill: ${greenDark};
	}
`;
